var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "d-flex flex-wrap justify-space-between" },
    _vm._l(_vm.addresses, function (address) {
      return _c(
        "div",
        { key: address.id, class: _setup.isMobile ? "mb-6" : "w-50 mb-6 pr-4" },
        [
          address.title
            ? _c(
                "h3",
                {
                  staticClass: "text-h6 text--text mt-0 mb-3",
                  attrs: { "data-qa": "ceo-contact-address-title" },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _setup.transDynamic(
                          address,
                          `title,${_setup.language},${_setup.needTranslate}`
                        )
                      ) +
                      "\n    "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          address.description
            ? _c(
                "p",
                {
                  staticClass: "text-body-1 text-secondary--text mb-3",
                  attrs: { "data-qa": "ceo-contact-address-description" },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _setup.transDynamic(
                          address,
                          `description,${_setup.language},${_setup.needTranslate}`
                        )
                      ) +
                      "\n    "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          address.address
            ? _c(
                "p",
                {
                  staticClass: "text-body-1 text--text mb-0",
                  attrs: { "data-qa": "ceo-contact-address-address" },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _setup.transDynamic(
                          address,
                          `address,${_setup.language},${_setup.needTranslate}`
                        )
                      ) +
                      "\n    "
                  ),
                ]
              )
            : _vm._e(),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }